import { Typography } from 'fronton-react';
import React, { PropsWithChildren } from 'react';
import { jc } from 'utils';
import { AvatarWithFallback, AvatarWithFallbackProps } from '../fronton-decorators/avatar-with-fallback';
import { ReviewContentFormatter } from '../review-content-formatter';
import { Styles } from './review.styles';
import { getDate, isValidDate } from './utils';

export type ReviewAuthorContentProps = {
  authorName: string;
  authorInitials: string;
  authorAvatarUrl?: string | null;
  avatarThemeColor?: AvatarWithFallbackProps['color'];
  date: Date;
  locale: string;
} & React.HTMLAttributes<HTMLElement>;

const PurchaseDate: React.FC<{ date: Date; locale: string }> = ({ date, locale }) => (
  <Typography variant="caption" color="text-minor" className={Styles.createdDate}>
    {getDate(date, locale)}
  </Typography>
);

export const ReviewAuthorContent: React.FC<ReviewAuthorContentProps> = ({
  authorName,
  authorInitials,
  authorAvatarUrl,
  avatarThemeColor,
  className = '',
  locale,
  date,
  ...htmlProps
}) => {
  return (
    <div className={jc(className, Styles.authorContainer)} {...htmlProps}>
      <AvatarWithFallback
        data-qa="review-avatar-fallback"
        imageSrc={authorAvatarUrl}
        name={authorInitials}
        color={avatarThemeColor}
      />
      <div className={Styles.authorBlock}>
        <ReviewContentFormatter
          components={{
            p: ({ children }) => <PersonTitle>{children}</PersonTitle>,
            a: ({ children }) => <span>{children}</span>,
            link: ({ children }) => <span>{children}</span>,
          }}
        >
          {authorName}
        </ReviewContentFormatter>
        {date && isValidDate(date) ? <PurchaseDate locale={locale} date={date} /> : null}
      </div>
    </div>
  );
};

const PersonTitle: React.FC<PropsWithChildren> = ({ children }) => (
  <Typography variant="s" size="subtitle" color="text-primary" className={Styles.personTitle}>
    {children}
  </Typography>
);
